// extracted by mini-css-extract-plugin
export default {"container":"SideSelectContainer_container__ptdfn"};